The collection of possible responses.

- `MultiSelect` questions contain at least two elements.
- `SingleSelect` questions contain at least two elements.
